<template>
	<fragment>
		<class-header
			:subname="lecture.category"
			:name="lecture.lecName"
			v-bind:menus="menus"
			v-bind:buttons="buttons"
			v-bind:mainmenuOpened="true"
			v-bind:sysmenuActive="false"
			:icon="lecture.lecIcon?lecture.lecIcon.atchFileId:''"
		></class-header>

		<section ref="container" class="container">
			<!-- side menus -->
			<nav class="side-nav">
				<a class="btn full-width round m-b-10" href="#none">새로운 시험 추가</a>
				<ul class="side-nav-menu bar clearfix">
					<li>
						<a href="#">찾아가는 국어문화학교(수강생용)</a>
					</li>
				</ul>
			</nav>
			<!-- //end .side-nav -->
			<div class="container-fiuld class-making-box clearfix">
				<div class="title-box b-b clearfix">
					<div class="f-18 pull-left text-blue p-10">찾아가는 국어문화학교 설문 (수강생용)</div>
					<!-- <a class="modify m-t-5 text-center" href="#none">수정</a> -->
					<div class="btn-group pull-right p-10 p-r-0">
						<div class="select pull-left m-r-5">
							<a class="btn round pull-left" href="#">
								<img class="v-mid m-r-5" src="images/x.png" alt=""> 액셀 다운로드
							</a>
						</div>
					</div>
				</div>
				<div class="white-box clearfix">
					<div class="input-group full-width">
						<span class="input-group-addon text-left">
							<p class="f-18 m-b-0 text-bold text-blue">시험1 - 아름다운 우리말 찾기</p>
							<p class="f-14 m-b-0">응시기간 : 2019년 7월 1일 ~ 2019년 7월 6일</p>
						</span>
						<span class="input-group-addon v-mid w140">
							<button class="btn round">시험문항</button>
						</span>
						<span class="input-group-addon v-mid w60">
							<a class="modify" href="#none">수정</a>
							<a class="del" href="#none">삭제</a>
						</span>
					</div>
					<textarea class="full-width m-t-15" cols="30" rows="10" placeholder="시험 설명" disabled=""></textarea>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">1.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 객관식 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							연령대가?
						</span>
						<span class="input-group-addon w80 v-mid">
							정답율 100%
						</span>
					</div>
					<!-- <hr class="m-t-15 m-b-15"> -->
					<div class="col-md-7">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio" checked>
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								10대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								20대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								30대
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="radio">
								<label for="table-check3">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								40대 이상
							</span>
						</div>
					</div>
					<div class="col-md-5 b-l">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
					</div>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">2.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 객관식 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							관심있는 분야는?
						</span>
						<span class="input-group-addon w80 v-mid">
							정답율 100%
						</span>
					</div>

					<div class="col-md-7">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox" checked>
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox">
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon w60 v-mid p-r-5">
								<input id="table-check3" class="checkbox4" type="checkbox">
								<label for="table-check3" class="sq">체크버튼</label>
							</span>
							<span class="input-group-addon text-left v-mid p-r-5">
								언어생활
							</span>
						</div>
					</div>

					<div class="col-md-5 b-l">
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
						<div class="input-group full-width m-b-10">
							<span class="input-group-addon v-mid p-r-5">
								<div class="progress full-width m-t-0">
									<span class="progress-bar" style="width:40%">40%</span>
								</div>
							</span>
							<span class="input-group-addon w60 text-left v-mid">
								5명
							</span>
						</div>
					</div>
				</div>

				<div class="white-box clearfix">
					<div class="input-group full-width m-b-15 p-b-10 b-b">
						<span class="input-group-addon w20 v-mid f-16 text-left">3.</span>
						<span class="input-group-addon w100 v-mid p-r-5">
							｜ 서술형 ｜
						</span>
						<span class="input-group-addon v-mid text-left p-r-5">
							오늘의 기분을 서술하시오?
						</span>
						<span class="input-group-addon w80 v-mid">
							정답율 100%
						</span>
					</div>
					<div class="input-group full-width m-b-15">
						<span class="input-group-addon w40 v-mid f-16 text-left"></span>
						<span class="input-group-addon v-mid f-16 text-left">
							오늘 아주 좋습니다.
						</span>
						<span class="input-group-addon w80 v-mid f-16 text-left"></span>
					</div>
				</div>
				<div class="b-t p-15 p-l-0 p-r-0 m-t-30 m-b-30 clearfix">
					<button class="btn btn-blue round w160 pull-left">등록하기</button>
					<button class="btn round w160 pull-right">새로 입력하기</button>
				</div>
			</div>
		</section>
		<common-footer></common-footer>
	</fragment>
</template>

<script>
import fnAdjustHeight from '../mixins/fnAdjustHeight.js'
import ClassHeader from '../components/ClassHeader.vue'
import CommonFooter from '../components/CommonFooter.vue'
//import axios from 'axios'
//import server from '../statics/server.js'

export default {
	// 컴포넌트 명
	name: 'ViewClassroomFinishTestResult',
	mixins: [fnAdjustHeight],
	// 이 컴포넌트에서 사용할 자식컴포넌트 목록
	components: {
		ClassHeader,
		CommonFooter,
	},

	mounted: async function() {
		const { lecId } = this.$route.params;
		this.lecture = await this.getLecInfo(lecId);
	},

	// 이 컴포넌트에서 내부적으로 사용할 데이터
	data: function() {
		return {
			menus : [
				{name:'강의 목차',link:"/classroom/"+this.$route.params.lecId+"/curriculum",selected:false},
				{name:'수강관리',link:"/classroom/"+this.$route.params.lecId+"/apply",selected:false},
				{name:'출결',link:"/classroom/"+this.$route.params.lecId+"/attendance",selected:false},
				{name:'시험',link:"/classroom/"+this.$route.params.lecId+"/exam",selected:true},
				{name:'과제',link:"/classroom/"+this.$route.params.lecId+"/assignment",selected:false},
				{name:'설문',link:"/classroom/"+this.$route.params.lecId+"/survey",selected:false},
				{name:'게시판',link:"/classroom/"+this.$route.params.lecId+"/board",selected:false},
			],
			side_menus: [],
			side_buttons : [],
			buttons : [],
			modals: {},
			lecture: {}
		}
	},



	// 이 컴포넌트에서 내부적으로 사용할 메써드
	methods: {

	}
}
</script>
<style scoped>
	.white-box{
		margin-top : 30px;
	}
</style>